package com.jingfangpai.common.json

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json

@OptIn(ExperimentalSerializationApi::class)
val json = Json{
    ignoreUnknownKeys = true;
    explicitNulls = false;
    encodeDefaults = true
    isLenient = true;
    coerceInputValues = true;
    allowStructuredMapKeys = true;
}

